/*eslint-disable*/ export const messages = {
    Apply: "Applica",
    "Changed the date": "Data modificata",
    Clear: "Cancella",
    "Date picker open, choose a date": "Selettore data aperto, scegli una data",
    "Date range picker open, select a date range": "Selettore intervallo di date aperto, seleziona intervallo di date",
    "End Date": "Data di fine",
    "Please enter a valid date ({format})": ["Inserisci una data valida (", ["format"], ")"],
    "Please select a date after {minDate}": ["Seleziona una data dopo il giorno ", ["minDate"]],
    "Please select a date before {maxDate}": ["Seleziona una data prima del giorno ", ["maxDate"]],
    "Show next month": "Mostra mese successivo",
    "Show previous month": "Mostra mese precedente",
    "Start Date": "Data di inizio",
    "The selected date is disabled": "La data selezionata è disabilitata",
    "The selected date is unavailable. Please select another.":
        "La data selezionata non è disponibile. Selezionane un'altra.",
    Today: "Oggi",
    "Today, {dateStr}": ["Oggi, ", ["dateStr"]],
    "date picker": "selettore data",
    "start date selected": "data di inizio selezionata",
    to: "a",
    "{dateStr}, select end date": [["dateStr"], ", seleziona data di fine"],
    "{dateStr}, select start date": [["dateStr"], ", seleziona data di inizio"],
    "{startDate} to {endDate}, choose apply to confirm, or cancel": [
        "Da ",
        ["startDate"],
        " a ",
        ["endDate"],
        ", scegli applica per confermare, oppure annulla",
    ],
};
